import { Spin } from "antd";
import {
  ArrowUpIcon,
  TodayIcon,
  ThisWeekIcon,
  ThisMonthIcon,
  ThisYearIcon,
  ArrowDownIcon,
} from "pages/internal-dashboard/icons";
import { ConditionalRenderer } from "components/conditonal-renderer";
import styles from "./styles.module.scss";

export function CustomBox({
  color,
  loading = false,
  userCount,
  boxData,
  percentage,
  percentages,
}: any) {
  const BoxIcon = boxData?.icon;
  const { day, month, week, year } = percentages || {};

  const loadingElement = (
    <ConditionalRenderer condition={loading}>
      <div className={styles.loading}>
        <Spin />
      </div>
    </ConditionalRenderer>
  );
  return (
    <div
      className={styles.totalUsers}
      style={{ "--color": color } as React.CSSProperties}
    >
      {loadingElement}
      <div className={styles.gradientBox}>
        <div className={styles.userText}>
          <span className={styles.userIcon}>{BoxIcon ? <BoxIcon /> : ""}</span>
          <h2 className={styles.title}>{boxData?.label}</h2>
          <p className={styles.description}>{boxData?.description}</p>
          <div className={styles.userCount}>{userCount}</div>
        </div>
        <div className={styles.valuesBoxes}>
          <div className={styles.firstRow}>
            <ValueBox
              boxTitle="Today"
              boxValue={boxData?.todayCount}
              icon={TodayIcon}
              color="#006AB3"
              percentage={day}
            />
            <ValueBox
              boxTitle="This Week"
              boxValue={boxData?.weekCount}
              icon={ThisWeekIcon}
              color="#F4BD00"
              percentage={week}
            />
          </div>
          <div className={styles.secondRow}>
            <ValueBox
              boxTitle="This Month"
              boxValue={boxData?.monthCount}
              icon={ThisMonthIcon}
              color="#78BA2C"
              percentage={month}
            />
            <ValueBox
              boxTitle="This Year"
              boxValue={boxData?.yearCount}
              icon={ThisYearIcon}
              color="#1C1C1D"
              percentage={year}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function ValueBox({ boxTitle, boxValue, icon, color, percentage }: any) {
  const percentageValue: number = Number(Number(percentage).toFixed(2));
  const DateIcon = icon;

  const isPositive: boolean = percentageValue >= 0;
  const iconToDisplay: JSX.Element = isPositive ? (
    <ArrowUpIcon />
  ) : (
    <ArrowDownIcon />
  );
  const percentageToDisplay: string | number = isPositive
    ? "+" + percentageValue
    : percentageValue;

  return (
    <div className={styles.valueBox}>
      <div className={styles.boxTitleIcon}>
        <div className={styles.boxIcon} style={{ backgroundColor: color }}>
          <DateIcon />
        </div>
        <div className={styles.text}>{boxTitle}</div>
      </div>
      <div className={styles.value}>{boxValue}</div>
      <div
        className={styles.percentage}
        style={{ visibility: isNaN(percentageValue) ? "hidden" : "visible" }}
      >
        {iconToDisplay}
        <span className={isPositive ? styles.increased : styles.decreased}>
          {percentageToDisplay}%
        </span>
      </div>
    </div>
  );
}
